var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.perfil == 0)?[_c('Inicio')]:[_c('Inicio2',{attrs:{"perfil":_vm.perfil}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }